import React, { Component } from 'react';
import './user.css';
import {Auth} from 'aws-amplify';
import LogIn from './userComponents/logIn';
import FirstTimePasswordChange from './userComponents/firstTimePasswordChange.js';
import MultiFactorAuthenticationSetup from './userComponents/multiFactorAuthenticationSetup';
import MultiFactorAuthentication from './userComponents/multiFactorAuthentication';
import VerifyEmail from './userComponents/verifyEmail';
import LoggedIn from './userComponents/loggedIn';

class User extends Component {

  state = {
    firstTimeUser: {},
    log: [],
    challengeName: 'LOADING'
  }

  componentDidMount() {

    setTimeout(() => {
      Auth.currentAuthenticatedUser()
      .then(res => {

        console.log(res);

        if (res.challengeName) this.setState({challengeName: res.challengeName});
        else this.setState({challengeName: 'LOGGED_IN'});

      })
      .catch(err => {

        if (err === 'not authenticated') {
          this.setState({challengeName: 'LOGGED_OUT'});
        }
        else {
          console.log(err);
        }

      });
    }, 0);

  }

  render() {

    const {updateUserState, pushToLog} = this;
    const {firstTimeUser, challengeName} = this.state;

    return (
      <div className="UserPage">

        {challengeName === 'LOADING'
        && <div><h1>Loading...</h1></div>}
        {challengeName === 'LOGGED_OUT'
        && <LogIn updateUserState={updateUserState} pushToLog={pushToLog}/>}
        {challengeName === 'NEW_PASSWORD_REQUIRED'
        && <FirstTimePasswordChange firstTimeUser={firstTimeUser} updateUserState={updateUserState} pushToLog={pushToLog}/>}
        {challengeName === 'MFA_SETUP'
        && <MultiFactorAuthenticationSetup firstTimeUser={firstTimeUser} updateUserState={updateUserState} pushToLog={pushToLog}/>}
        {challengeName === 'SOFTWARE_TOKEN_MFA'
        && <MultiFactorAuthentication firstTimeUser={firstTimeUser} updateUserState={updateUserState} pushToLog={pushToLog}/>}
        {challengeName === 'VERIFY_EMAIL'
        && <VerifyEmail updateUserState={updateUserState} pushToLog={pushToLog}/>}
        {challengeName === 'LOGGED_IN'
        && <LoggedIn updateUserState={updateUserState} pushToLog={pushToLog}/>}

        <div className="Log">
          {this.state.log.map(entry => {
            return <p className="LogEntry" key={entry}>{`> ${entry.slice(entry.indexOf(' - ') + 2)}`}</p>;
          })}
        </div>

      </div>
    );
  }

  updateUserState = updateObject => {
    this.setState(updateObject);
    this.props.checkUsersGroup();
  }

  pushToLog = entry => {

    const {log} = this.state;

    const now = new Date(Date.now());
    const hours = now.getHours() < 10 ? `0${now.getHours()}` : now.getHours();
    const minutes = now.getMinutes() < 10 ? `0${now.getMinutes()}` : now.getMinutes();
    const seconds = now.getSeconds() < 10 ? `0${now.getSeconds()}` : now.getSeconds();
    const date = now.getDate() < 10 ? `0${now.getDate()}` : now.getDate();
    const month = now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1;
    const datedEntry = `${Date.now()} - ${hours}:${minutes}:${seconds} ${date}/${month}/${now.getFullYear()} - ${entry}`;
    this.setState({log: [datedEntry, ...log]});

  }

}

export default User;


// WEBPACK FOOTER //
// ./src/components/content/user/user.js